import type { PropsWithChildren, FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from '@retailer-platform/shared-components/src/tds'
import EmptyView from '../../../../../components/EmptyView'
import { useGoToAddStoreGroup } from '../../../utils/navigation.hooks'

export const StoreGroupsListEmptyState: FunctionComponent<PropsWithChildren<unknown>> = () => {
  const goToAddStoreGroup = useGoToAddStoreGroup()

  return (
    <EmptyView
      size="large"
      iconName="folder"
      title={<FormattedMessage id="settings.storeGroups.list.emptyState.title" />}
      body={<FormattedMessage id="settings.storeGroups.list.emptyState.body" />}
      action={
        <Button onClick={goToAddStoreGroup} data-testid="add-group-empty-state-button">
          <FormattedMessage id="settings.storeGroups.list.emptyState.addGroup" />
        </Button>
      }
    />
  )
}
